import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import VerbSelect from '../../../../shared/components/formComponents/inputs/VerbSelect';

class AssetSelections extends PureComponent {
    static propTypes = {
        onChange: PropTypes.func,
        learningAssets: PropTypes.array,
        defaultValue: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.defaultValue || { value: '', label: '' }
        };
    }

    onChange = (value) => {
        this.setState(() => ({
            value
        }));
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };

    render() {
        const { learningAssets } = this.props;
        const { value } = this.state;
        const selectProps = {
            clearable: true,
            autoload: false,
            simpleValue: true,
            labelKey: 'name',
            valueKey: '_id',
            options: learningAssets,
            value,
            onInputChange: this.onChange
        };
        return <VerbSelect onChange={this.onChange} {...selectProps} />;
    }
}

export default AssetSelections;
